import styled from 'styled-components'

import { ButtonBase } from '@components/ui'
import { CustomDialog, CustomDialogBody } from '@components/ui/Dialogs'

export const StyledDialog = styled(CustomDialog)`
  width: 924px;
`

export const DateFilterWrapperDiv = styled.div`
  display: grid;
  grid-template-columns: auto 196px;
  gap: 20px;

  & > *:nth-child(3) {
    grid-column: span 2;
  }

  // customize datepicker
  .react-datepicker {
    width: 100%;

    .react-datepicker__month-container {
      float: unset;
    }

    .react-datepicker__month-container .react-datepicker__day-names,
    .react-datepicker__month .react-datepicker__week {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      justify-items: center;
    }

    .react-datepicker__header .react-datepicker__day-names {
      margin-left: 0.4rem;
      margin-right: 0.4rem;
    }
  }
`

export const FilterWrapper = styled.div``

export const StatusFilterWrapper = styled(FilterWrapper)`
  & > *:last-child {
    padding: 0;
  }
`

export const FilterDialogBody = styled(CustomDialogBody)`
  display: flex;
  flex-direction: column;
  padding: 0;

  & > * {
    padding: 20px;
  }

  & > *:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray[110]};
  }
`

export const IncludeExcludeFilterWrapper = styled(FilterWrapper)`
  display: flex;
  gap: 20px;

  & > div {
    flex: 1;
  }
`

export const ChoicesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
`

export const StyledButtonBase = styled(ButtonBase)`
  height: 100%;
  flex-wrap: wrap;
  flex: 1;
  padding: 15px 28px;
  min-width: 210px;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  justify-content: flex-start;
  color: ${({ theme }) => theme.colors.gray[50]};
  border-radius: 0;
  border: none;
  background-color: transparent;

  &:hover {
    background-color: ${({ theme }) => theme.colors.common.oceanBlue}10;
  }
`

export const ButtonLabel = styled.span`
  display: flex;
  align-items: center;
  height: 30px;
  margin-top: -5px;
  text-transform: uppercase;
`

export const ButtonValue = styled.span`
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: block;
  height: 30px;
  line-height: 30px;
  width: 100%;
`

export const MenuContainer = styled.div`
  padding: 20px;
`
